<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";

import BaseRoutes from "@/enums/routes/BaseRoutes.ts";

const router = useRouter();
</script>

<template>
  <div class="picking-layout general-app flex flex-col">
    <header class="bg-header px-4 lg:px-8 py-4 flex items-center sticky top-0 left-0 z-50">
      <div class="flex items-center sm:flex-row flex-col">
        <h1 class="text-white text-3xl font-normal text-left w-full">Mixit App</h1>
      </div>
      <div class="flex gap-4 ml-auto items-center items-center">
        <Button
          icon="pi pi-home"
          class="text-lg text-lg text-white btn-blue rounded-full border-0 shadow-none"
          @click="router.push({ name: BaseRoutes.APPS })"
        />
      </div>
    </header>
    <div class="px-4 lg:px-8 py-6 flex flex-col flex-auto">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
.picking-layout {
  background-color: #282828;
  min-height: calc(100vh - env(safe-area-inset-bottom));
}
.bg-header {
  background-color: #141414;
}

@media (max-width: 768px) {
  .sign-in-out-btn {
    padding: 0.5rem;

    .p-button-icon {
      margin-right: 0;
    }

    .p-button-label {
      display: none;
    }
  }
}
</style>
